import React from "react";
import type { RouteObject } from "react-router-dom";
import { DigitalNameCardScreen } from "./pages/dnc/dnc.screen";

export const routesDigitalNameCard: RouteObject[] = [
  { path: "home", index: true, element: <DigitalNameCardScreen /> },
];
